/*
	TKIO Static Money Converter
	- Converts hard-coded JPY amounts in static content to selected currency
	- Supported currencies (11): JPY, USD, EUR, GBP, AUD, CAD, CNY, KRW, THB, VND, IDR
	- Sources rates from exchangerate.host (CORS-enabled), caches for 24h
	- Opt-in markup: <span class="tkio-money" data-money-jpy="7000">¥7,000</span>
	- Opt-in container text scanning: add data-money-scan="true" to a container to convert "¥7,000" or "1,500円" patterns inside
*/
(function () {
	var SUPPORTED = ['JPY', 'USD', 'EUR', 'GBP', 'AUD', 'CAD', 'CNY', 'KRW', 'THB', 'VND', 'IDR'];
	var DECIMALS = { JPY: 0, USD: 2, EUR: 2, GBP: 2, AUD: 2, CAD: 2, CNY: 2, KRW: 0, THB: 2, VND: 0, IDR: 0 };
	var SYMBOLS = { JPY: '¥', USD: '$', EUR: '€', GBP: '£', AUD: 'A$', CAD: 'C$', CNY: '元', KRW: '₩', THB: '฿', VND: '₫', IDR: 'Rp' };
	var LS_KEY = 'tkio_fx_rates_v1';
	var LS_TS_KEY = 'tkio_fx_rates_ts_v1';
	var CACHE_MS = 24 * 60 * 60 * 1000; // 24h

	function clearRatesCache() {
		try { localStorage.removeItem(LS_KEY); localStorage.removeItem(LS_TS_KEY); } catch (e) { }
	}

	function shouldClearByParam() {
		try {
			var p = new URLSearchParams(window.location.search);
			return p.get('nocache') === '1' || p.get('clearCache') === '1';
		} catch (e) { return false; }
	}

	function getParams() {
		try { return new URLSearchParams(window.location.search); } catch (e) { return new URLSearchParams(''); }
	}

	function getActiveCurrency() {
		try {
			// Highest priority: explicit selection via URL param or selector
			var p = getParams().get('currency');
			if (p && SUPPORTED.indexOf(p) !== -1) return p;
			// 1) Custom currency select (if present)
			var sel = document.getElementById('lc-currency-select');
			if (sel && SUPPORTED.indexOf(sel.value) !== -1) return sel.value;
			// 2) Server-embedded current currency (Shopify localization)
			if (window.tkioActiveCurrency && SUPPORTED.indexOf(window.tkioActiveCurrency) !== -1) {
				return window.tkioActiveCurrency;
			}
			// 3) Shopify localization buttons: try all and pick the first ISO code found
			var spans = document.querySelectorAll('.localization-form__select span');
			for (var i = 0; i < spans.length; i++) {
				var txt = String(spans[i].textContent || '');
				var m = txt.match(/\b([A-Z]{3})\b/);
				if (m && SUPPORTED.indexOf(m[1]) !== -1) return m[1];
			}
			// 4) Shopify global object (if available)
			if (window.Shopify && window.Shopify.currency && typeof window.Shopify.currency === 'string' && SUPPORTED.indexOf(window.Shopify.currency) !== -1) {
				return window.Shopify.currency;
			}
		} catch (e) { }
		return 'JPY';
	}

	function getCachedRates() {
		// Optional: force clear via URL param
		if (shouldClearByParam()) clearRatesCache();
		try {
			var ts = +localStorage.getItem(LS_TS_KEY) || 0;
			var now = Date.now();
			if (now - ts < CACHE_MS) {
				var raw = localStorage.getItem(LS_KEY);
				if (raw) {
					var cached = JSON.parse(raw);
					// Validate cached: must contain at least one non-JPY supported currency
					var hasValid = Object.keys(cached || {}).some(function (k) { return k !== 'JPY' && SUPPORTED.indexOf(k) !== -1 && typeof cached[k] === 'number' && cached[k] > 0; });
					if (hasValid) return cached;
					// If invalid (e.g., only JPY=1), fall through to inline/remote sources
				}
			}
			// Immediate inline fallback if embedded
			if (window.tkioRates && window.tkioRates.rates) {
				var out = { JPY: 1 };
				Object.keys(window.tkioRates.rates).forEach(function (k) {
					if (SUPPORTED.indexOf(k) !== -1) out[k] = window.tkioRates.rates[k];
				});
				// Cache inline rates for future
				setCachedRates(out);
				return out;
			}
		} catch (e) { }
		return null;
	}

	function setCachedRates(rates) {
		try {
			localStorage.setItem(LS_KEY, JSON.stringify(rates));
			localStorage.setItem(LS_TS_KEY, String(Date.now()));
		} catch (e) { }
	}

	function fetchRates() {
		return new Promise(function (resolve) {
			var cached = getCachedRates();
			if (cached) return resolve(cached);
			var symbols = SUPPORTED.filter(function (c) { return c !== 'JPY'; }).join(',');
			var url = 'https://api.exchangerate.host/latest?base=JPY&symbols=' + encodeURIComponent(symbols);
			var useFallback = function () {
				try {
					if (window.tkioRatesAssetUrl) {
						fetch(window.tkioRatesAssetUrl, { cache: 'no-cache' })
							.then(function (r) { return r.json(); })
							.then(function (data) {
								var out = { JPY: 1 };
								if (data && data.rates) {
									Object.keys(data.rates).forEach(function (k) { if (SUPPORTED.indexOf(k) !== -1) out[k] = data.rates[k]; });
								}
								setCachedRates(out);
								resolve(out);
							})
							.catch(function () { resolve({ JPY: 1 }); });
					} else {
						resolve({ JPY: 1 });
					}
				} catch (e) { resolve({ JPY: 1 }); }
			};
			try {
				fetch(url, { mode: 'cors', cache: 'no-cache' })
					.then(function (r) { return r.json(); })
					.then(function (data) {
						var out = { JPY: 1 };
						if (data && data.rates) {
							Object.keys(data.rates).forEach(function (k) { if (SUPPORTED.indexOf(k) !== -1) out[k] = data.rates[k]; });
						}
						setCachedRates(out);
						resolve(out);
					})
					.catch(useFallback);
			} catch (e) { useFallback(); }
		});
	}

	function format(currency, amount) {
		var d = DECIMALS[currency] || 0;
		var sym = SYMBOLS[currency] || currency + ' ';
		var fixed = amount.toFixed(d);
		var parts = fixed.split('.');
		var intPart = parts[0];
		var frac = parts[1] ? ('.' + parts[1]) : '';
		var withCommas = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
		// Positioning:
		// - CNY: suffix as Chinese "元" (e.g., 1,234.56元)
		// - Others: prefix symbol (e.g., $1,234.56, ¥7,000)
		if (currency === 'CNY') {
			return withCommas + frac + sym;
		}
		return sym + withCommas + frac;
	}

	function parseJPYString(str) {
		// Accept numbers like "7,000" or "7000" optionally followed by 円
		var m = str.match(/(\d{1,3}(?:,\d{3})*)(?:\s*円)?/);
		if (!m) return null;
		var num = m[1].replace(/,/g, '');
		var v = parseFloat(num);
		return isNaN(v) ? null : v;
	}

	function convertValue(jpy, toCurrency, rates) {
		var rate = rates[toCurrency] || 1;
		return jpy * rate;
	}

	function processOptInElements(rates, toCurrency) {
		var nodes = document.querySelectorAll('[data-money-jpy], [data-jpy]');
		nodes.forEach(function (el) {
			try {
				var base = el.getAttribute('data-money-jpy') || el.getAttribute('data-jpy');
				var jpyVal = parseFloat(String(base).replace(/,/g, ''));
				if (isNaN(jpyVal)) return;
				if (toCurrency === 'JPY') {
					el.textContent = '¥' + String(Math.round(jpyVal)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
					return;
				}
				var converted = convertValue(jpyVal, toCurrency, rates);
				el.textContent = format(toCurrency, converted);
			} catch (e) { }
		});
	}

	function walkTextNodes(root, cb) {
		var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
		var node;
		while ((node = walker.nextNode())) {
			cb(node);
		}
	}

	function processScanContainers(rates, toCurrency) {
		var containers = document.querySelectorAll('[data-money-scan="true"], .tkio-money-scan');
		containers.forEach(function (root) {
			// Skip typical price components to avoid double-transforming product prices
			if (root.closest('.price, .price-item, product-price, .cart__totals')) return;
			walkTextNodes(root, function (textNode) {
				var txt = textNode.nodeValue;
				if (!txt) return;
				// Patterns: "¥7,000" or "1,500円" or "7000円"
				var replaced = txt
					.replace(/¥\s*(\d{1,3}(?:,\d{3})*(?:\.\d+)?)/g, function (_, num) {
						var jpyVal = parseFloat(num.replace(/,/g, ''));
						if (isNaN(jpyVal)) return _;
						if (toCurrency === 'JPY') return '¥' + num;
						var converted = convertValue(jpyVal, toCurrency, rates);
						return format(toCurrency, converted);
					})
					.replace(/(\d{1,3}(?:,\d{3})*(?:\.\d+)?)\s*円/g, function (full, num) {
						var jpyVal = parseFloat(num.replace(/,/g, ''));
						if (isNaN(jpyVal)) return full;
						if (toCurrency === 'JPY') return '¥' + num;
						var converted = convertValue(jpyVal, toCurrency, rates);
						return format(toCurrency, converted);
					});
				if (replaced !== txt) textNode.nodeValue = replaced;
			});
		});
	}

	function applyConversion() {
		var toCurrency = getActiveCurrency();
		fetchRates().then(function (rates) {
			try {
				if (window.console && console.debug) {
					var sample = 7000 * (rates[toCurrency] || 1);
					console.debug('[TKIO money] currency=', toCurrency, 'rate=', rates[toCurrency], 'sample7000->', sample);
				}
				processOptInElements(rates, toCurrency);
				processScanContainers(rates, toCurrency);
			} catch (e) { }
		});
	}

	function wireCurrencySelect() {
		var sel = document.getElementById('lc-currency-select');
		if (sel) sel.addEventListener('change', function () {
			// When user changes currency, drop cached rates to avoid stale conversion
			clearRatesCache();
			setTimeout(applyConversion, 50);
		});
		// Also observe Shopify localization button text changes (rarely needed; selection usually reloads)
		var btnSpan = document.querySelector('.localization-form__select span');
		if (btnSpan && window.MutationObserver) {
			var mo = new MutationObserver(function () { setTimeout(applyConversion, 50); });
			mo.observe(btnSpan, { characterData: true, subtree: true, childList: true });
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () { wireCurrencySelect(); applyConversion(); });
	} else {
		wireCurrencySelect(); applyConversion();
	}
})();
